import { notification } from 'antd'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getAuditTrailLogs } from 'src/app/shared/services/BackgroundService'
import { GetAuditTrailLogRequestModel } from 'src/app/shared/models/auditTrailLog.model'

export interface IAuditTrailLogHook {
  resultList: any
  isGettingList: boolean
  getResultList: (payload: Partial<GetAuditTrailLogRequestModel>, isDownload?: boolean) => Promise<any>
}

export const useAuditTrailLog = (): IAuditTrailLogHook => {
  const [resultList, setResultList] = useState<any>({
    items: [],
    total: 0,
  })
  const [api] = notification.useNotification()
  const { t } = useTranslation()

  const [isGettingList, setIsGettingList] = useState<boolean>(false)

  const getResultList = useCallback(
    async (payload: Partial<GetAuditTrailLogRequestModel>, isDownload = false) => {
      try {
        setIsGettingList(true)
        const res = await getAuditTrailLogs(payload as GetAuditTrailLogRequestModel)
        if (res?.data && !isDownload) {
          setResultList(res?.data)
        }
        return res?.data
      } catch (error: any) {
        if (error?.response?.status === 404) {
          console.warn('Audit Trail Log API not available:', error?.message)
          setResultList({ items: [], total: 0 })
          return { items: [], total: 0 }
        }
        api.error({
          message: t('common:error'),
          description: error?.message || error?.error || 'An error occurred',
          placement: 'topRight',
        })
      } finally {
        setIsGettingList(false)
      }
    },
    [api, t],
  )

  return {
    resultList,
    isGettingList,
    getResultList,
  }
}
